import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import Vue from 'vue'
import enUS from "../locales/en-US";
import ptBR from "../locales/pt-BR";

Vue.use(VueI18Next);

i18next.init({
    lng: 'en-US',
    resources: { 'en-US': enUS, 'pt-BR': ptBR }
});

export const i18n = new VueI18Next(i18next);

Vue.filter("t", value => {
    if (!value) return ""
    return i18n.t(value)
})

Vue.prototype.$getMoney = () => money[i18next.language]
Vue.prototype.$getMask = (type) => {
    switch (type) {
        case 'phone':
            return maskPhone[i18next.language]
    }
}

const money = {
    'en-US': {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        suffix: '',
        precision: 2,
        masked: false
    },
    'pt-BR': {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
    }
}

const maskPhone = {
    'en-US': '(###) ###-####',
    'pt-BR': ['(##) ####-####', '(##) #####-####']
}